(()=>{
  const limit=16,memory=new Map(),volatile=new Set(),mounted=new WeakSet(),jobs=new WeakMap();
  function cancel(mount){const job=mount&&jobs.get(mount);if(!job)return;job.cancelled=true;job.observer?.disconnect();job.controllers.forEach(controller=>controller.abort());job.controllers.clear();}
  const valid=id=>typeof id==='string'&&id.length>0&&id.length<=200&&!/[\/\\?#.\s\u0000-\u001f]/u.test(id);
  function clean(items){return Array.isArray(items)?[...new Set(items.filter(valid))].slice(0,limit+1):[];}
  function read(key){
    let items=memory.get(key)||[];if(volatile.has(key))return clean(items);
    try{const raw=localStorage.getItem(key);items=raw===null?[]:raw.length<=10000?clean(JSON.parse(raw)):[];}catch{volatile.add(key);}
    return clean(items);
  }
  function write(key,items){memory.set(key,items);try{localStorage.setItem(key,JSON.stringify(items));volatile.delete(key);}catch{volatile.add(key);}}
  function visit(current,key='oukumen-recent-local-v1'){
    if(!valid(current))return[];
    const previous=read(key).filter(id=>id!==current).slice(0,limit);
    write(key,[current,...previous]);return previous;
  }
  function forget(id,key){write(key,read(key).filter(item=>item!==id));}
  window.OukumenRecent={visit,limit,clear(){write('oukumen-recent-local-v1',[]);write('oukumen-recent-shopify-v1',[]);}};
  document.addEventListener('click',event=>{
    const clear=event.target.closest('[data-recent-clear]');
    if(clear){
      window.OukumenRecent.clear();
      document.querySelectorAll('[data-recent-section]').forEach(section=>{
        const mount=section.closest('[data-native-recent]');if(mount){mount.dataset.recentCleared='true';cancel(mount);}
        section.querySelector('[data-recent-grid]')?.replaceChildren();section.hidden=true;
      });return;
    }
    const button=event.target.closest('[data-recent-step]');if(!button)return;
    const grid=button.closest('[data-recent-section]')?.querySelector('[data-recent-grid]');
    if(grid)grid.scrollBy({left:Number(button.dataset.recentStep)*grid.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
  });
  function initializeNative(root=document){
    const mount=root.querySelector('[data-native-recent]');
    if(!mount?.dataset?.currentHandle||mounted.has(mount))return;mounted.add(mount);if(mount.dataset.editorPreview==='true')return;
    const key='oukumen-recent-shopify-v1',handles=visit(mount.dataset.currentHandle,key).slice(0,Math.min(16,Math.max(1,Number(mount.dataset.recentLimit)||16)));
    if(!handles.length){mount.hidden=true;return;}
    const section=mount.querySelector('[data-recent-section]'),grid=mount.querySelector('[data-recent-grid]');
    if(!section||!grid)return;
    const job={cancelled:false,started:false,controllers:new Set(),observer:null};jobs.set(mount,job);
    const active=()=>!job.cancelled&&mount.dataset.recentCleared!=='true'&&mount.isConnected!==false;
    async function load(){
      if(job.started||!active())return;job.started=true;
      const cards=new Array(handles.length);let next=0;
      async function worker(){
        while(next<handles.length&&active()){
          const index=next++,handle=handles[index],controller=new AbortController(),timer=setTimeout(()=>controller.abort(),7000);
          job.controllers.add(controller);
          try{
            const base=(mount.dataset.rootUrl||'/').replace(/\/?$/,'/'),url=new URL(base+'products/'+encodeURIComponent(handle),location.origin);url.searchParams.set('view','recent-card');
            const response=await fetch(url,{signal:controller.signal,credentials:'same-origin'});
            if(!active())return;
            if(!response.ok){if(response.status===404||response.status===410)forget(handle,key);continue;}
            const text=await response.text();if(!active())return;
            const parsed=new DOMParser().parseFromString(text,'text/html'),card=parsed.querySelector('article.product');
            if(card)cards[index]=card;
          }catch{}finally{clearTimeout(timer);job.controllers.delete(controller);}
        }
      }
      await Promise.all(Array.from({length:Math.min(3,handles.length)},worker));
      if(!active())return;
      const available=cards.filter(Boolean);if(!available.length){mount.hidden=true;return;}
      grid.replaceChildren(...available);section.hidden=false;window.OukumenPhotos?.initialize(grid);
    }
    if(typeof IntersectionObserver==='function'){
      const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){observer.disconnect();load();}},{rootMargin:'300px'});job.observer=observer;observer.observe(mount);
    }else load();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initializeNative(),{once:true});else initializeNative();
  document.addEventListener('shopify:section:load',event=>initializeNative(event.target));
  document.addEventListener('shopify:section:unload',event=>cancel(event.target.matches?.('[data-native-recent]')?event.target:event.target.querySelector('[data-native-recent]')));
})();
